<div class="ad-step1">
        <div class="container">
            <div class="level-bar pt-5 pb-5">
                <div class="half-line level-bar-active"></div>
                <div class="level level-bar-active">1</div>
                <div class="full-line level-bar-active"></div>
                <div class="level level-bar-active">2</div>
                <div class="full-line"></div>
                <div class="level">3</div>
                <div class="full-line"></div>
                <div class="level">4</div>
                <div class="full-line"></div>
                <div class="level">5</div>
                <div class="full-line"></div>
                <div class="level"><img src="assets/check-red.png" style="width: 26px; height: auto" alt=""></div>
                <div class="full-line"></div>
            </div>
            <div class="level-text">
                Step 2 of 5
            </div>
            <div class="page-contents">
                <div class="heading">
                    <h1>Fit the location of your property</h1>
                    <p>5 steps to post ad of your property.</p>
                </div>
                <div class="form-contents">
                    <h3>Property location</h3>
                    <form [formGroup]="secondAdForm">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6">
                                Province <span class="theme-text">*</span><br>
                                <select formControlName="province_id" (change)='onProvinceSelected($event.target.value)'>
                                    <option value="null" disabled [selected]="true">Choose the province</option>
                                    <option *ngFor="let province of provinceList" [value]="province.id">{{ province.province }}</option>
                                </select> Municipality <span class="theme-text">*</span><br>
                                <select formControlName="municipality_id" (change)="onMunicipalitySelected($event.target.value)">
                                    <option value="null" disabled [selected]="true">Choose the municipality</option>
                                    <option *ngFor="let municipality of validMunicipalityList" [value]="municipality.id">{{ municipality.municipality }}</option>
                                </select>
                                Village/Area <br>
                                <input type="text" formControlName="village" placeholder="Enter the village">
                            </div>
                            <div class="col-12 col-sm-12 col-md-6">
                                District <span class="theme-text">*</span><br>
                                <select formControlName="district_id" (change)="onDistrictSelected($event.target.value)">
                                    <option value="null" disabled [selected]="true">Choose the district</option>
                                    <option *ngFor="let district of validDistrictList" [value]="district.id">{{ district.district }}</option>
                                </select> Ward Number <span class="theme-text">*</span><br>
                                <input type="number" formControlName="wardNumber" placeholder="Enter ward number">
                                Distance From Road
                                <input class="unit-holder" formControlName="distFromRoad" type="number" placeholder="Distance From Road">
                                <span class="unit">
                                    <select class="small-unit unit-select" [(ngModel)]="selectedUnitDistance" [ngModelOptions]="{standalone: true}">
                                        <option value="Meter">Meter</option>
                                        <option value="Feet">Feet</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                        Pin the location of your property
                        <form>
                            <div class="form-group">
                                <input #location placeholder="Search ..." class="form-control">
                            </div>
                            <div class="user-location-map" #mapContainer id="map"></div>
                        </form>
                        <div class="row justify-content-between pt-5 px-3">
                            <button (click)="previous()">← &nbsp;&nbsp;&nbsp; Previous Step</button>
                            <button [disabled]="secondAdForm.invalid" (click)="next()">Next Step &nbsp;&nbsp;&nbsp;→</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>